module.exports = __webpack_public_path__ + "img/create-wallet-m-3-en.c7a42a5a.png";